// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3zWbk","upload":"Small_upload__hND6a","imageWrap":"Small_imageWrap__2ezUL","removeBtn":"Small_removeBtn__2t6yc"};